import {
  type GameCriteria,
  type GameQualifier,
  isAccountStatusId,
  isEmpty,
  isNotEmpty,
} from '@terros/common'
import { Info } from 'luxon'
import { type GameCriteriaFormData, type PitchQualifierForForm, type QualifierForForm } from './types'

export const getCriteriaInitialFormValues = (criteria?: GameCriteria): GameCriteriaFormData => {
  if (!criteria) {
    return {
      name: '',
      pointsPerMetric: 1,
      boostDays: [],
      boostMultiplier: 1,
      boostEnabled: false,
      qualifiers: [],
      field: null,
      type: 'exists',
      pitchQualifier: undefined,
    }
  }

  const { boostMultiplier, qualifiers, ...rest } = criteria

  return {
    ...rest,
    boostDays: boostMultiplier?.days.map((n) => WEEKDAYS[n - 1]) ?? [],
    boostMultiplier: boostMultiplier?.multiplier ?? 1,
    boostEnabled: isNotEmpty(boostMultiplier),
    qualifiers: getInitialQualifiers(criteria),
    pitchQualifier: getPitchQualifier(criteria),
  }
}

export const WEEKDAYS = Info.weekdays()

const getInitialQualifiers = (criteria: GameCriteria): QualifierForForm[] => {
  if (criteria.field === 'contact.pitch') return []
  if (isEmpty(criteria.qualifiers)) return []
  return criteria.qualifiers.map(toInitialQualifier)
}

const toInitialQualifier = (qualifier: GameQualifier): QualifierForForm => {
  const { minPercent, ...rest } = qualifier
  return {
    ...rest,
    minPercent: minPercent * 100,
  }
}

export const toUpdatedCriteria = (existing: GameCriteria[], updated: GameCriteria): GameCriteria[] => {
  const criteria = existing.filter((a) => a.field !== updated.field)
  criteria.push(updated)
  return criteria
}

const getPitchQualifier = (criteria: GameCriteria): PitchQualifierForForm => {
  const nullQualifier: PitchQualifierForForm = { field: null, name: null, perPitches: null }
  if (criteria.field !== 'contact.pitch') return nullQualifier
  if (isEmpty(criteria.qualifiers)) return nullQualifier
  const { field, name, minPercent } = criteria.qualifiers[0]
  if (!isAccountStatusId(field)) return nullQualifier
  const perPitches = Math.round(1 / minPercent)
  return { field, name, perPitches }
}
